"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PinPlusIcon = function PinPlusIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M9 11h2V4.067C11 1.852 9.209 1 7 1s-4 .852-4 3.067v7.922L7 16l2-2.005zM5 6.022a2 2 0 1 1 2 2 2 2 0 0 1-2-2zM16 14h-2v2h-2v-2h-2v-2h2v-2h2v2h2z"
    }) : _react["default"].createElement("path", {
      d: "M13 12h3v1h-3v3h-1v-3H9v-1h3V9h1zm-4.792 1.582L7 14.794l-3.1-3.108v-7.76C3.9 2.51 4.943 1.79 7 1.79s3.1.719 3.1 2.137V8h.9V4.067C11 1.852 9.209 1 7 1s-4 .852-4 3.067v7.922L7 16l1.996-2a.981.981 0 0 1-.788-.418zM7 8.022a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm1-2a1 1 0 1 0-1 1 1 1 0 0 0 1-1z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M15 19a1 1 0 0 1 1-1h1.552l.448-.451V5.619C18 2.283 15.313 1 12 1S6 2.283 6 5.619v11.93l6 6.04 3-3.02zM9 8a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm15 13h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
    }) : _react["default"].createElement("path", {
      d: "M19 24v-4.001h-4V19h4v-4h1v4h4v.999h-4V24zm-4.94-3.703L12 22.371l-5.1-5.133V5.488c0-3.05 2.773-3.69 5.1-3.69s5.1.64 5.1 3.69V14h.9V5.619C18 2.283 15.313 1 12 1S6 2.283 6 5.619v11.93l6 6.04 2.644-2.662a.984.984 0 0 1-.584-.63zM12 11a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm2-3a2 2 0 1 0-2 2 2.003 2.003 0 0 0 2-2z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M19 24h4.448l.552-.556V6.543C24 1.817 20.194 0 15.5 0S7 1.817 7 6.543v16.901L15.5 32l3.5-3.523zm-8.1-13.5a4.6 4.6 0 1 1 4.6 4.6 4.599 4.599 0 0 1-4.6-4.6zM32 27h-5v5h-2v-5h-5v-2h5v-5h2v5h5z"
  }) : _react["default"].createElement("path", {
    d: "M31 25v.999h-5V31h-1v-5.001h-5V25h5v-5h1v5zm-11.673 1.73L15.5 30.58 8 23.032V6.543C8 1.962 12.078 1 15.5 1s7.5.962 7.5 5.543V19h1V6.543C24 1.817 20.194 0 15.5 0S7 1.817 7 6.543v16.901L15.5 32l4.968-5.001H20a.99.99 0 0 1-.673-.27zM15.5 6a4.5 4.5 0 1 1-4.5 4.5A4.499 4.499 0 0 1 15.5 6zm0 1a3.5 3.5 0 1 0 3.5 3.5A3.504 3.504 0 0 0 15.5 7z"
  }));
};

var _default = PinPlusIcon;
exports["default"] = _default;